module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sitesetting"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px 32px 16px 16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("站点设置")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', [_c('span', [_vm._v("站点名称")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "站点名称"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("站点地址")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "站点地址"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("该页面功能暂未开发完成")])])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-700ed00a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/sitesetting/index.vue
// module id = 2386
// module chunks = 1